import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import {filter, switchMap} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {Deserialize} from 'cerialize';
import {SynthesePostesConsommation} from '../../models/rt2012/synthesePostesConsommation';
import { format } from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class SynthesePostesConsommationService {
  baseApiUrl: string = environment.api.baseUrl;

  protected _synthesePostesConsommation: BehaviorSubject<SynthesePostesConsommation[]> = new BehaviorSubject(null);
  public readonly synthesePostesConsommation: Observable<SynthesePostesConsommation[]> = this._synthesePostesConsommation.asObservable().pipe(filter(c => c != null));
  protected _errors: BehaviorSubject<string[]> = new BehaviorSubject(null);
  public readonly errors: Observable<string[]> = this._errors.asObservable().pipe(filter(c => c != null));

  constructor(private http: HttpClient) {

  }

  getAll(logementId: number, from: Date, to: Date, type: string): Observable<SynthesePostesConsommation[]> {
    return this.http.get<any>(`${this.baseApiUrl}rt2012/postes-de-consommation/synthese-par-${type}/${logementId}/${format(from, 'yyyy-MM-dd')}/${format(to, 'yyyy-MM-dd')}`)
      .pipe(switchMap(data => {
          let hasErrors = false;
          data.consommations.forEach(function (value) {
            if (
              value.consommation_autres < 0
              || value.consommation_chauffage < 0
              || value.consommation_ecs < 0
              || value.consommation_prises_electrique < 0
              || value.consommation_refroidissement < 0
            ) {
              hasErrors = true;
            }
          });
          if (hasErrors) {
            data.consommations = [];
            data.errors.push('Le graphique n’est pas disponible en raison de la détection de valeur incohérente dans les données de consommation')
          }
          const syntheses = Deserialize(data.consommations, SynthesePostesConsommation);
          this._synthesePostesConsommation.next(syntheses);
          this._errors.next(data.errors);

          return this.synthesePostesConsommation;
        })
      );
  }
}
